import { useLocation } from 'react-router-dom';
import QuickDepositModal from './quick-deposit-modal.js';
import ExternalIframeRequest from '~/components/external-iframe-request.js';

const QDExternalPanel = ({ onClose, setResultParams }) => {
	const location = useLocation();
	return (
		<QuickDepositModal>
			<ExternalIframeRequest
				setResultParams={setResultParams}
				onClose={onClose}
				hideHeader
				fillHeight
				fullLocation={location?.state?.mainLocation}
			/>
		</QuickDepositModal>
	);
};

export default QDExternalPanel;
